import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { times } from 'lodash';
import React from 'react';
import { TableCell } from '../../common';
import { getYearCount } from './utils';
export var PeriodCells = function (_a) {
  var periodLength = _a.periodLength,
    chunkSize = _a.chunkSize,
    isIncludeAverage = _a.isIncludeAverage,
    isIncludeTotal = _a.isIncludeTotal,
    renderCell = _a.renderCell,
    renderTotalCell = _a.renderTotalCell,
    renderAverageCell = _a.renderAverageCell;
  var yearCount = getYearCount(periodLength, chunkSize);
  return _jsx(_Fragment, {
    children: times(yearCount, function (year) {
      return _jsxs(React.Fragment, {
        children: [times(chunkSize, function (month) {
          var periodIdx = month + year * chunkSize;
          if (periodIdx >= periodLength) return null;
          return _jsx(React.Fragment, {
            children: renderCell(periodIdx, year, month)
          }, month);
        }), isIncludeTotal && (renderTotalCell ? renderTotalCell(year) : _jsx(TableCell, {}, "total")), isIncludeAverage && (renderAverageCell === null || renderAverageCell === void 0 ? void 0 : renderAverageCell(year))]
      }, year);
    })
  });
};